import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { Tags } from '@treams/treams-ui';

export default function FeedbackTemplateSelector(props: {
	template?: graphql.FeedbackTemplate;
	onChange: (template?: graphql.FeedbackTemplate) => void;
	showPrivate?: boolean;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();
	const query = graphql.useFeedbackTemplateSelectorQuery();

	let options: { title: string; value: string; data: graphql.FeedbackTemplate }[] =
		query.data?.feedbackTemplates.edges.map(({ node }) => ({
			title: localize(node.title).text,
			value: node.id,
			data: node as graphql.FeedbackTemplate,
		})) ?? [];

	if (!props.showPrivate) {
		options = options.filter((option) => !option.data.isPrivate);
	}

	return (
		<Flex>
			<Tags.Item.Select
				options={options}
				label={t('feedback.templates.selector.searchPlaceholder')}
				search
				selectedValue={options.find((option) => option.value === props.template?.id)?.value}
				onChange={(value: any) => {
					props.onChange(options.find((option) => option.value === value)?.data);
				}}
			/>
		</Flex>
	);
}
